module.exports = __webpack_public_path__ + "img/arrow-h-dark.a2def110.png";